"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCandidatesAnswers = useCandidatesAnswers;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const view_models_1 = require("../../view-models/index.js");
function useCandidatesAnswers() {
    const candidatesAnswers = (0, stores_1.useCalculatorStore)((state) => state.data.candidatesAnswers);
    return (0, react_1.useMemo)(() => {
        const filteredCandidatesAnswers = {};
        for (const [candidateId, answers] of Object.entries(candidatesAnswers)) {
            filteredCandidatesAnswers[candidateId] = answers.filter((answer) => answer.respondent === "candidate" || answer.respondent === "expert");
        }
        return (0, view_models_1.candidatesAnswersViewModel)(filteredCandidatesAnswers);
    }, [candidatesAnswers]);
}
